module.exports = __webpack_public_path__ + "static/media/Placaj-ceramic-Klinker-Asuan.282fbf15.jpg";